var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-confirmation-dialog',{attrs:{"text":_vm.text},on:{"confirm":_vm.remove},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","loading":_vm.loading}},on),[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("clear")])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }